var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkRemoveMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.989636 0.726562H7.09678C7.32817 0.726562 7.55008 0.818481 7.71369 0.982097C7.87731 1.14571 7.96923 1.36762 7.96923 1.59901V11.196C7.96913 11.2737 7.94824 11.35 7.90873 11.417C7.86922 11.484 7.81252 11.5392 7.74451 11.5769C7.67649 11.6146 7.59964 11.6335 7.5219 11.6315C7.44416 11.6295 7.36836 11.6068 7.30235 11.5656L4.04321 9.52903L0.784611 11.5656C0.718594 11.6069 0.642739 11.6298 0.564916 11.6318C0.487094 11.6339 0.410139 11.615 0.342039 11.5773C0.273939 11.5396 0.217174 11.4843 0.177636 11.4173C0.138098 11.3502 0.117226 11.2738 0.117188 11.196V1.59901C0.117188 1.36762 0.209106 1.14571 0.372722 0.982097C0.536338 0.818481 0.758249 0.726562 0.989636 0.726562Z",
    fill: "#CBA67A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkRemoveMini);
export default __webpack_public_path__ + "static/media/bookmark-remove-mini.36df08d3230fbd600048256d798c6e2e.svg";
export { ForwardRef as ReactComponent };